import { useNavigate, useParams } from "react-router";
import { CancelConfirmStep } from "@/features/reservation/components/CancelConfirmStep";

/**
 * 予約キャンセル画面 (/reservations/:reservationToken/cancel)。予約アクセストークンは
 * ReservationTokenLayout が interceptor へ渡すため、本画面はキャンセル成功後の遷移だけを担う。
 */
export default function CancelConfirmPage() {
  const { reservationToken = "" } = useParams<{ reservationToken: string }>();
  const navigate = useNavigate();

  return (
    <CancelConfirmStep
      onCancelComplete={() => navigate(`/reservations/${reservationToken}/cancel/complete`)}
    />
  );
}
